var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1587_7773)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.81386 6.4245L1.08659 11.8245C0.9625 11.9415 0.800227 12 0.636364 12C0.4725 12 0.310227 11.9415 0.186136 11.8245C-0.0620455 11.5905 -0.0620455 11.211 0.186136 10.9755L5.46318 6L0.186136 1.0245C-0.0620455 0.7905 -0.0620455 0.4095 0.186136 0.1755C0.434318 -0.0585 0.838409 -0.0585 1.08659 0.1755L6.81386 5.5755C7.06205 5.8095 7.06205 6.189 6.81386 6.4245Z",
    fill: "#6763B7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1587_7773"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkArrowRight);
export default __webpack_public_path__ + "static/media/link-arrow-right.6372d633e1166faa564330b801606629.svg";
export { ForwardRef as ReactComponent };